import { Middleware, applyMiddleware, compose, createStore } from 'redux';
import { createLogger } from 'redux-logger';
import reducers from './rootReducers';
import { appMiddleware } from './middlewares/app';
import { coreMiddleware } from './middlewares/core';
import thunkMiddleware from 'redux-thunk';
import { getPreviousStateOnAdditionalProductsPage } from '../../utilites/util';

const loggerMiddleware = createLogger({
  predicate: () => process.env.NODE_ENV === 'development',
}) as unknown as Middleware<any, any, any>;
const composeEnhancers = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(
  reducers,
  getPreviousStateOnAdditionalProductsPage(),
  composeEnhancers(
    applyMiddleware(
      thunkMiddleware,
      loggerMiddleware,
      ...appMiddleware,
      ...coreMiddleware,
    ),
  ),
);

export default store;
